import { SHELF_POS } from 'src/constants/shelfArtifacts'

const handleSubmit = async ({ description }, { props: { addShelfArtifact, onClose, shelf } }) => {
  await addShelfArtifact(shelf, SHELF_POS, description)
  onClose()
}

export default handleSubmit
